var _path, _path2, _path3, _path4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvitationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_111_12273",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 14.5C15 14.5 16 14.5 16 13.5C16 12.5 15 9.5 11 9.5C7 9.5 6 12.5 6 13.5C6 14.5 7 14.5 7 14.5H15ZM7.02235 13.5H14.9777C14.9811 13.4996 14.986 13.499 14.9919 13.498C14.9946 13.4975 14.9973 13.497 15 13.4965C14.9985 13.2325 14.8331 12.4669 14.2407 11.7758C13.6867 11.1294 12.7173 10.5 11 10.5C9.28269 10.5 8.31334 11.1294 7.75926 11.7758C7.16687 12.4669 7.00146 13.2325 7.00001 13.4965C7.00266 13.497 7.00538 13.4975 7.00815 13.498C7.01403 13.499 7.01888 13.4996 7.02235 13.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 7.5C12.1046 7.5 13 6.60457 13 5.5C13 4.39543 12.1046 3.5 11 3.5C9.89543 3.5 9 4.39543 9 5.5C9 6.60457 9.89543 7.5 11 7.5ZM14 5.5C14 7.15685 12.6569 8.5 11 8.5C9.34315 8.5 8 7.15685 8 5.5C8 3.84315 9.34315 2.5 11 2.5C12.6569 2.5 14 3.84315 14 5.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93593 9.77996C6.56813 9.66232 6.15954 9.57679 5.70628 9.53306C5.48195 9.51141 5.24668 9.5 5 9.5C1 9.5 0 12.5 0 13.5C0 14.1667 0.333333 14.5 1 14.5H5.21636C5.07556 14.2159 5 13.8791 5 13.5C5 12.4897 5.37724 11.458 6.08982 10.5962C6.33327 10.3017 6.61587 10.0271 6.93593 9.77996ZM4.92004 10.5005C3.25249 10.5197 2.30468 11.1395 1.75926 11.7758C1.16424 12.47 1 13.2393 1 13.5H4C4 12.4547 4.32256 11.4136 4.92004 10.5005Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 6C1.5 4.34315 2.84315 3 4.5 3C6.15685 3 7.5 4.34315 7.5 6C7.5 7.65685 6.15685 9 4.5 9C2.84315 9 1.5 7.65685 1.5 6ZM4.5 4C3.39543 4 2.5 4.89543 2.5 6C2.5 7.10457 3.39543 8 4.5 8C5.60457 8 6.5 7.10457 6.5 6C6.5 4.89543 5.60457 4 4.5 4Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_111_12273)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#A0AEC0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitationIcon);
export default __webpack_public_path__ + "static/media/invitation_icon.202be548f6d0f7bc61a40822c3d7df3f.svg";
export { ForwardRef as ReactComponent };